import { ElementType, ReactNode, FC } from 'react';
import type { CommonHTMLAttributes } from '@frontend/types';
import { useActiveTab } from './tabs.provider';

type Props = Omit<CommonHTMLAttributes, 'id'> & {
  as?: ElementType | FC<React.PropsWithChildren<unknown>>;
  children: ReactNode;
  controller: string;
  keepMounted?: boolean;
};

export const TabPanel = ({ as = 'section', controller, keepMounted = true, ...rest }: Props) => {
  const { activeTab } = useActiveTab();
  const hidden = activeTab !== controller;
  const Component = as;

  if (!keepMounted && hidden) {
    return null;
  }

  return (
    <Component {...rest} role='tabpanel' hidden={hidden} aria-labelledby={controller} id={`${controller}-panel`} />
  );
};
